/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import axios from 'axios';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Switch,
  Textarea,
} from '@jem-open/jem-ui';
import { Plus, Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';

import { environment } from '../../../environment/environment';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import { localStorageService } from '../../../services';
import {
  QUESTION_TYPES,
  PLATFORMS,
  CATEGORIES,
} from '../../../constants/educationQuestions';

/**
 * @summary AddEducationQuestion component
 *
 * @component
 */
class AddEducationQuestionView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      containerState: 'STATE_NEW',
      template: '',
      platform: 'whatsapp',
      category: 'Custom',
      isActive: false,
      type: 'multiple choice - single selection',
      answers: [],
      formError: false,
      errors: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleAnswerInputChange = this.handleAnswerInputChange.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({ [name]: value });
  }

  handleAnswerInputChange(i, event) {
    const { target } = event;

    if (target.name === 'answer') {
      const answers = [...this.state.answers];
      answers[i] = target.value;
      this.setState({ answers });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const user = localStorageService.getUserOrThrow();
    const currentUserId = user.id;
    const answersList = [];

    const { answers, platform, type, template, isActive, category } =
      this.state;

    // eslint-disable-next-line no-unused-expressions
    answers &&
      answers.map((answer) =>
        answersList.push({
          template: answer,
          order_weight: '1',
          added_by: currentUserId,
          platform,
        })
      );

    if (this.validateFormInput()) {
      const payload = {
        question_type: type,
        template,
        platform,
        is_active: isActive,
        category,
        added_by: currentUserId,
        answers: answersList,
      };

      axios
        .post(`${environment.baseUrl}/questions/`, payload)
        .then(() => {
          Swal.fire({
            title: 'Question successfully added',
            icon: 'success',
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 10000,
            timerProgressBar: true,
          });
          this.setState({ containerState: 'STATE_OK' });
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error adding question', error);
          this.setState({ containerState: 'STATE_ERROR' });
        });
    }
  }

  validateFormInput() {
    const { platform, type, template, isActive, category } = this.state;
    const errors = [];

    if (!template) {
      errors.push('Question template cannot be blank.');
    } else if (!platform) {
      errors.push('Please select a target platform.');
    } else if (!category) {
      errors.push('Please select a question category.');
    } else if (!type) {
      errors.push('Please select a question type.');
    } else if (isActive === '' || isActive === undefined) {
      errors.push('Please check the Active toggle.');
    }

    if (errors.length > 0) {
      this.setState({ formError: true, errors });
      return false;
    }

    this.setState({ formError: false, errors: [] });
    return true;
  }

  removeClick(i) {
    const answers = [...this.state.answers];
    answers.splice(i, 1);
    this.setState({ answers });
  }

  addClick() {
    this.setState((prevState) => ({ answers: [...prevState.answers, ''] }));
  }

  render() {
    const { platform, type, template, category, isActive, answers, formError, errors } =
      this.state;

    if (this.state.containerState === 'STATE_OK') {
      this.props.history.push('/admin/questions/education');
      return null;
    }

    return (
      <div className="min-h-screen bg-white p-md">
        <div
          className="-mx-md -mt-md mb-md px-md py-lg"
          style={{ backgroundColor: 'rgba(237,244,251,0.5)' }}>
          <h1 className="m-none font-heading text-2xl font-semibold text-greyscale-text-title">
            Add Question
          </h1>
          <p className="m-none mt-xxs max-w-2xl text-sm text-greyscale-text-body">
            Create a new chatbot education question and its answers.
          </p>
        </div>

        <form onSubmit={this.handleSubmit} className="mx-auto w-full max-w-3xl">
          {formError && errors.length > 0 && (
            <Alert variant="destructive" className="mb-md">
              <AlertTitle>Please fix the following</AlertTitle>
              <AlertDescription>
                <ul className="m-none list-disc pl-md">
                  {errors.map((error) => (
                    <li key={error}>{error}</li>
                  ))}
                </ul>
              </AlertDescription>
            </Alert>
          )}

          <div className="rounded-xl border border-greyscale-border-default bg-white p-md shadow-sm">
            <h2 className="m-none mb-sm font-heading text-lg font-semibold text-greyscale-text-title">
              New Question
            </h2>

            <div className="flex flex-col gap-sm">
              <div className="flex flex-col gap-xxs">
                <Label htmlFor="questionTemplate">Template</Label>
                <Textarea
                  name="template"
                  id="questionTemplate"
                  value={template}
                  onChange={this.handleInputChange}
                  placeholder="Enter the question text"
                />
              </div>

              <div className="flex flex-col gap-xxs">
                <Label>Type</Label>
                <Select
                  value={type}
                  onValueChange={(value) => this.setState({ type: value })}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select type" />
                  </SelectTrigger>
                  <SelectContent>
                    {QUESTION_TYPES.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="flex flex-col gap-xxs">
                <Label>Platform</Label>
                <Select
                  value={platform}
                  onValueChange={(value) => this.setState({ platform: value })}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select platform" />
                  </SelectTrigger>
                  <SelectContent>
                    {PLATFORMS.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="flex flex-col gap-xxs">
                <Label>Category</Label>
                <Select
                  value={category}
                  onValueChange={(value) => this.setState({ category: value })}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select category" />
                  </SelectTrigger>
                  <SelectContent>
                    {CATEGORIES.map((option) => (
                      <SelectItem key={option} value={option}>
                        {option}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="flex items-center gap-xs">
                <Switch
                  id="isActiveSwitch"
                  checked={isActive}
                  onCheckedChange={(checked) =>
                    this.setState({ isActive: checked })
                  }
                />
                <div>
                  <Label htmlFor="isActiveSwitch">Active</Label>
                  <p className="m-none text-xs text-greyscale-text-caption">
                    Make this question visible in the chatbot.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-md rounded-xl border border-greyscale-border-default bg-white p-md shadow-sm">
            <div className="mb-sm flex items-center justify-between">
              <h2 className="m-none font-heading text-lg font-semibold text-greyscale-text-title">
                Answers
              </h2>
              <Button
                type="button"
                variant="outline"
                size="sm"
                leftIcon={<Plus className="h-4 w-4" />}
                onClick={() => this.addClick()}>
                Add Answer
              </Button>
            </div>

            {answers.length === 0 ? (
              <p className="m-none text-sm text-greyscale-text-caption">
                No answers added yet.
              </p>
            ) : (
              <div className="flex flex-col gap-sm">
                {answers.map((answer, i) => (
                  <div key={`answer_${i}`} className="flex items-start gap-xs">
                    <Textarea
                      name="answer"
                      value={answer || ''}
                      onChange={(answerEvent) =>
                        this.handleAnswerInputChange(i, answerEvent)
                      }
                      placeholder={`Answer ${i + 1}`}
                      className="flex-1"
                    />
                    <Button
                      type="button"
                      variant="destructive"
                      size="sm"
                      leftIcon={<Trash2 className="h-4 w-4" />}
                      onClick={() => this.removeClick(i)}>
                      Remove
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-md flex justify-end gap-xs">
            <Button
              type="button"
              variant="outline"
              onClick={() =>
                this.props.history.push('/admin/questions/education')
              }>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Save
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default AddEducationQuestionView;
